import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
import placeholder from './-assets/placeholder-rule-and-policy.png';
export const Route = createFileRoute('/_staff/people/_list/rule-and-policy')({
  component: () => <ComingSoonCover placeholderImage={placeholder} />
});